      (function(){
        var searchRoot = document.querySelector('.wubs-ps:not([data-wubs-ps-initialized])');
        if(!searchRoot) return;
        searchRoot.setAttribute('data-wubs-ps-initialized', 'true');
        var sid = searchRoot.getAttribute('data-sid') || 'wubs';
        var header = document.getElementById('wubs-header-' + sid);
        if(!header) return;

        var searchBtns = header.querySelectorAll('.wubs-h__searchBtn, .header__tools-icon--search, [data-wubs-ps-toggle]');
        searchBtns = Array.prototype.slice.call(searchBtns || []).filter(Boolean);
        if(!searchBtns.length) return;

        var dock = header.querySelector('[data-wubs-ps-dock]');
        var dockInner = header.querySelector('[data-wubs-ps-dock-inner]');
        var closeBtn = header.querySelector('[data-wubs-ps-close]');
        var form = header.querySelector('[data-wubs-ps-form]');
        var input = header.querySelector('[data-wubs-ps-input]');
        var results = header.querySelector('[data-wubs-ps-results]');
        var suggest = header.querySelector('[data-wubs-ps-suggest]');
        var chips = header.querySelector('[data-wubs-ps-chips]');
        var grid = header.querySelector('[data-wubs-ps-grid]');
        var empty = header.querySelector('[data-wubs-ps-empty]');

        if(!dock || !results || !input || !grid) return;
        if(header.dataset.wubsPsBoot === '1') return;
        header.dataset.wubsPsBoot = '1';

        var searchType = searchRoot.getAttribute('data-search-type') || 'product';
        var searchLimit = parseInt(searchRoot.getAttribute('data-search-limit'), 10) || 8;
        if(searchLimit < 4) searchLimit = 4;
        if(searchLimit > 12) searchLimit = 12;

        var DISPLAY_LIMIT = searchLimit;

        var PC_SHOW_VENDOR = searchRoot.getAttribute('data-show-vendor') !== 'false';
        var PC_SHOW_ATC    = searchRoot.getAttribute('data-show-atc') !== 'false';
        var PC_SHOW_ARROWS = searchRoot.getAttribute('data-show-arrows') !== 'false';
        var PC_SHOW_STOCK  = searchRoot.getAttribute('data-stock-enabled') !== 'false';
        var PC_STOCK_DOT   = searchRoot.getAttribute('data-stock-show-dot') !== 'false';

        var TEXT = {
          empty: searchRoot.getAttribute('data-empty-text') || '',
          searching: searchRoot.getAttribute('data-searching-text') || '',
          previousImage: searchRoot.getAttribute('data-previous-image') || '',
          nextImage: searchRoot.getAttribute('data-next-image') || '',
          chooseOptions: searchRoot.getAttribute('data-choose-options') || '',
          addToCart: searchRoot.getAttribute('data-add-to-cart') || '',
          outOfStock: searchRoot.getAttribute('data-out-of-stock') || '',
          inStock: searchRoot.getAttribute('data-in-stock') || ''
        };

        var widths = [360,540,720,900,1200,1500];

        var base = (window.routes && window.routes.predictive_search_url) ? window.routes.predictive_search_url : '/search/suggest';
        var predictiveJson = (String(base).indexOf('.json') > -1) ? base : (base + '.json');

        var aborterJson = null;
        var aborterProducts = null;
        var tmr = null;

        var locked = false;
        var scrollY = 0;

        var productCache = {};

        var pageBackdrop = document.getElementById('wubs-ps-pagebackdrop-' + sid);
        if(!pageBackdrop){
          pageBackdrop = document.createElement('div');
          pageBackdrop.id = 'wubs-ps-pagebackdrop-' + sid;
          pageBackdrop.setAttribute('aria-hidden', 'true');
        }
        if(pageBackdrop.parentNode !== header) header.appendChild(pageBackdrop);

        function setDockVar(){
          var h = 0;
          try{ h = dockInner ? (dockInner.getBoundingClientRect().height || 0) : 0; }catch(e){ h = 0; }
          document.documentElement.style.setProperty('--wubs-psdock-h', Math.round(h) + 'px');
        }

        function setExpanded(v){
          for(var i=0;i<searchBtns.length;i++){
            try{ searchBtns[i].setAttribute('aria-expanded', v ? 'true' : 'false'); }catch(e){}
          }
        }

        function lockScroll(lock){
          try{
            if(lock){
              if(locked) return;
              locked = true;

              scrollY = window.scrollY || window.pageYOffset || 0;

              document.documentElement.classList.add('wubs-ps-lock');
              document.body.classList.add('wubs-ps-lock');

              document.body.style.position = 'fixed';
              document.body.style.top = (-scrollY) + 'px';
              document.body.style.left = '0';
              document.body.style.right = '0';
              document.body.style.width = '100%';
            } else {
              if(!locked) return;
              locked = false;

              document.documentElement.classList.remove('wubs-ps-lock');
              document.body.classList.remove('wubs-ps-lock');

              document.body.style.position = '';
              document.body.style.top = '';
              document.body.style.left = '';
              document.body.style.right = '';
              document.body.style.width = '';

              window.scrollTo(0, scrollY);
            }
          }catch(e){}
        }

        function updateBackdrop(){
          try{
            var on = header.classList.contains('is-search-expanded');

            var topPx = 0;
            try{
              topPx = Math.round(header.getBoundingClientRect().bottom || 0);
            }catch(e){ topPx = 0; }
            pageBackdrop.style.top = topPx + 'px';

            if(on) pageBackdrop.classList.add('is-on');
            else pageBackdrop.classList.remove('is-on');
          }catch(e){}
        }

        function clearResults(){
          if(grid) grid.innerHTML = '';
          if(empty){
            empty.textContent = TEXT.empty;
            empty.hidden = true;
          }
        }

        function focusInputNow(){
          try{
            input.focus();
            try{ input.click(); }catch(e){}
          }catch(e){}
        }

        function esc(s){
          return String(s || '')
            .replace(/&/g,'&amp;')
            .replace(/</g,'&lt;')
            .replace(/>/g,'&gt;')
            .replace(/"/g,'&quot;')
            .replace(/'/g,'&#039;');
        }

        function debounce(fn, ms){
          return function(){
            var args = arguments;
            window.clearTimeout(tmr);
            tmr = window.setTimeout(function(){ fn.apply(null, args); }, ms);
          };
        }

        function uniqTypes(str){
          var out = [];
          var seen = {};
          String(str || '')
            .split(',')
            .map(function(s){ return (s || '').trim(); })
            .filter(Boolean)
            .forEach(function(t){
              if(seen[t]) return;
              seen[t] = true;
              out.push(t);
            });
          return out;
        }

        function buildUrl(term){
          var params = new URLSearchParams();
          params.set('q', term);

          var types = uniqTypes(String(searchType || 'product') + ',collection');
          params.set('resources[type]', types.join(','));

          var reqLimit = Math.max(80, DISPLAY_LIMIT * 10);
          params.set('resources[limit]', String(reqLimit));
          params.set('resources[options][unavailable_products]', 'last');

          return predictiveJson + '?' + params.toString();
        }

        function extract(json){
          var res = (json && json.resources && json.resources.results) ? json.resources.results : {};
          var products = (res.products || res.product || []);
          var collections = (res.collections || res.collection || []);
          return {
            products: Array.isArray(products) ? products : [],
            collections: Array.isArray(collections) ? collections : []
          };
        }

        function showCollections(colls){
          var items = (colls || [])
            .map(function(c){
              var title = (c && (c.title || c.name)) || '';
              var url = (c && (c.url || '')) || '';
              title = String(title || '').trim();
              url = String(url || '').trim();
              if(!title || !url) return null;
              return { title: title, url: url };
            })
            .filter(Boolean)
            .slice(0, 10);

          if(!items.length){
            if(suggest) suggest.hidden = true;
            if(chips) chips.innerHTML = '';
            return;
          }

          if(suggest) suggest.hidden = false;
          if(chips){
            chips.innerHTML = items.map(function(c){
              return '<a class="wubs-ps__chipLink" href="' + esc(c.url) + '">' + esc(c.title) + '</a>';
            }).join('');
          }
        }

        function closeThemeSearch(){
          try{
            var openDetails = document.querySelectorAll(
              'details.search-modal[open], details#Details-HeaderSearch[open], details[open][data-search-modal]'
            );
            for(var i=0;i<openDetails.length;i++){
              openDetails[i].removeAttribute('open');
            }
          }catch(e){}

          try{
            document.documentElement.classList.remove('overflow-hidden','overflow-hidden-tablet','overflow-hidden-mobile');
            document.body.classList.remove('overflow-hidden','overflow-hidden-tablet','overflow-hidden-mobile');
          }catch(e){}
        }

        function open(){
          closeThemeSearch();

          try{
            document.dispatchEvent(new CustomEvent('wubs:cart-close', {
              detail: { sid: sid, immediate: true }
            }));
          }catch(e){}

          dock.hidden = false;
          results.hidden = true; /* viktigt: visa inte vit ruta innan typing */

          setDockVar();

          header.classList.add('is-search-open');
          header.classList.remove('is-search-expanded');
          setExpanded(true);
          updateBackdrop();

          focusInputNow();
          window.setTimeout(focusInputNow, 60);

          /* Ingen lock här - först när resultat visas */
          lockScroll(false);
        }

        function close(){
          closeThemeSearch();

          header.classList.remove('is-search-expanded');
          header.classList.remove('is-search-open');
          setExpanded(false);

          input.value = '';
          clearResults();
          showCollections([]);
          updateBackdrop();

          lockScroll(false);

          dock.hidden = true;
          results.hidden = true;
          setDockVar();
        }

        function expand(){
          results.hidden = false;
          header.classList.add('is-search-expanded');
          updateBackdrop();
          lockScroll(true);
        }

        function collapse(){
          header.classList.remove('is-search-expanded');
          results.hidden = true;
          updateBackdrop();
          lockScroll(false);
        }

        function preventBehindScroll(e){
          if(!header.classList.contains('is-search-expanded')) return;
          var t = e && e.target;

          try{
            if(results && t && (results === t || results.contains(t))) return;
            if(dock && t && (dock === t || dock.contains(t))) return;
          }catch(err){}

          if(e && typeof e.preventDefault === 'function') e.preventDefault();
        }

        document.addEventListener('wheel', preventBehindScroll, { passive:false, capture:true });
        document.addEventListener('touchmove', preventBehindScroll, { passive:false, capture:true });

        pageBackdrop.addEventListener('click', function(){ close(); });
        pageBackdrop.addEventListener('wheel', function(e){ e.preventDefault(); }, { passive:false });
        pageBackdrop.addEventListener('touchmove', function(e){ e.preventDefault(); }, { passive:false });

        document.addEventListener('pointerdown', function(e){
          if(!header.classList.contains('is-search-open')) return;

          var target = e && e.target;
          if(!target) return;
          if(dock.contains(target) || results.contains(target)) return;

          for(var i=0;i<searchBtns.length;i++){
            if(searchBtns[i] === target || searchBtns[i].contains(target)) return;
          }

          close();
        }, true);

        function productHandle(p){
          if(p && p.handle) return String(p.handle);
          var url = (p && p.url) ? String(p.url) : '';
          var m = url.match(/\/products\/([^\/\?\#]+)/);
          return (m && m[1]) ? m[1] : '';
        }

        function rootPath(){
          try{
            if(window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root;
          }catch(e){}
          return '/';
        }

        function fetchProductJson(handle, signal){
          var h = String(handle || '').trim();
          if(!h) return Promise.resolve(null);

          if(productCache[h]) return Promise.resolve(productCache[h]);

          var url = rootPath() + 'products/' + encodeURIComponent(h) + '.js';

          return fetch(url, {
            signal: signal,
            headers: { 'Accept': 'application/json' },
            credentials: 'same-origin'
          })
          .then(function(r){ if(!r.ok) throw new Error(String(r.status)); return r.json(); })
          .then(function(obj){
            productCache[h] = obj;
            return obj;
          });
        }

        function imgUrl(u, w){
          var url = String(u || '');
          if(!url) return '';
          if(!w) return url;
          if(url.indexOf('width=') > -1) return url;
          return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + String(w);
        }

        function buildSrcset(u){
          var base = String(u || '');
          if(!base) return '';
          return widths.map(function(w){
            return imgUrl(base, w) + ' ' + w + 'w';
          }).join(', ');
        }

        function moneyNoTrailingZeros(str){
          var s = String(str || '');
          s = s.replace(/([\,\.]00)(\D|$)/, '$2');
          return s;
        }

        function formatMoney(cents){
          var c = parseInt(cents || '0', 10);
          if(isNaN(c)) c = 0;

          try{
            if(window.Shopify && typeof Shopify.formatMoney === 'function'){
              var fmt =
                (window.theme && (theme.moneyFormat || theme.money_format)) ||
                (window.Shopify && Shopify.money_format) ||
                '\u007b\u007bamount\u007d\u007d kr';
              return moneyNoTrailingZeros(Shopify.formatMoney(c, fmt));
            }
          }catch(e){}

          var val = (c / 100).toFixed(2);
          val = val.replace(/\.00$/, '').replace(/\,00$/, '');
          return val + ' kr';
        }

        function pickVariant(p){
          var vs = (p && p.variants) ? p.variants : [];
          if(!vs.length) return null;
          for(var i=0;i<vs.length;i++){
            if(vs[i] && vs[i].available) return vs[i];
          }
          return vs[0];
        }

        function buildCardHtml(p){
          if(!p) return '';

          var title = String(p.title || '').trim();
          var url = String(p.url || ('/products/' + (p.handle || ''))) || '';
          var vendor = String(p.vendor || '').trim();

          var images = Array.isArray(p.images) ? p.images : [];
          var featured = p.featured_image || (images.length ? images[0] : '');
          var imgCount = images.length;

          var v = pickVariant(p);
          var variantId = v ? parseInt(v.id || '0', 10) : 0;
          var available = v ? !!v.available : false;

          var needsQuickAdd = false;
          try{
            needsQuickAdd = (p.variants && p.variants.length > 1);
          }catch(e){ needsQuickAdd = false; }

          var priceHtml = '';
          if(p.price_varies){
            priceHtml = formatMoney(p.price_min) + ' - ' + formatMoney(p.price_max);
          } else if(v && typeof v.price !== 'undefined'){
            priceHtml = formatMoney(v.price);
          } else if(typeof p.price !== 'undefined'){
            priceHtml = formatMoney(p.price);
          } else {
            priceHtml = '';
          }

          var mainSrc = featured ? imgUrl(featured, 1200) : '';
          var mainSrcset = featured ? buildSrcset(featured) : '';

          var carouselImgs = [];
          var imgdataSpans = [];

          if(featured){
            carouselImgs.push(
              '<img class="wubs-pc__cimg" src="' + esc(imgUrl(featured, 1200)) + '" srcset="' + esc(mainSrcset) + '" sizes="100vw" alt="' + esc(title) + '" loading="lazy" draggable="false">'
            );
            imgdataSpans.push(
              '<span data-wubs-pc-imgitem data-src="' + esc(imgUrl(featured, 1200)) + '" data-srcset="' + esc(mainSrcset) + '"></span>'
            );
          }

          var count = 0;
          for(var i=0;i<images.length;i++){
            var im = images[i];
            if(!im) continue;
            if(featured && im === featured) continue;

            count++;
            if(count > 9) break; /* featured + 9 = max 10 */

            var ss = buildSrcset(im);
            carouselImgs.push(
              '<img class="wubs-pc__cimg" src="' + esc(imgUrl(im, 1200)) + '" srcset="' + esc(ss) + '" sizes="100vw" alt="' + esc(title) + '" loading="lazy" draggable="false">'
            );
            imgdataSpans.push(
              '<span data-wubs-pc-imgitem data-src="' + esc(imgUrl(im, 1200)) + '" data-srcset="' + esc(ss) + '"></span>'
            );
          }

          var arrowsHtml = '';
          if(PC_SHOW_ARROWS && imgCount > 1){
            arrowsHtml =
              '<button type="button" class="wubs-pc__nav wubs-pc__nav--prev" aria-label="' + esc(TEXT.previousImage) + '" data-wubs-pc-nav="prev">' +
                '<svg class="wubs-pc__navIcon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
                  '<path d="M14.5 6.5L9 12l5.5 5.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"></path>' +
                '</svg>' +
              '</button>' +
              '<button type="button" class="wubs-pc__nav wubs-pc__nav--next" aria-label="' + esc(TEXT.nextImage) + '" data-wubs-pc-nav="next">' +
                '<svg class="wubs-pc__navIcon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
                  '<path d="M9.5 6.5L15 12l-5.5 5.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"></path>' +
                '</svg>' +
              '</button>';
          }

          var atcHtml = '';
          if(PC_SHOW_ATC && variantId){
            var ariaLabel = TEXT.outOfStock;
            if(available){
              ariaLabel = needsQuickAdd ? TEXT.chooseOptions : TEXT.addToCart;
            }

            atcHtml =
              '<button type="button" class="wubs-pc__atc" data-wubs-pc-atc ' +
                'data-vid="' + esc(String(variantId)) + '" ' +
                'data-qa="' + (needsQuickAdd ? '1' : '0') + '" ' +
                'data-handle="' + esc(String(p.handle || '')) + '" ' +
                'data-url="' + esc(url) + '" ' +
                'aria-label="' + esc(ariaLabel) + '" ' +
                (available ? '' : 'disabled aria-disabled="true"') +
              '>' +
                '<svg class="wubs-pc__atcIcon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
                  '<path d="M12 5v14M5 12h14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path>' +
                '</svg>' +
              '</button>';
          }

          var mediaHtml = '';
          if(featured){
            mediaHtml =
              '<img class="wubs-pc__img" src="' + esc(mainSrc) + '" srcset="' + esc(mainSrcset) + '" sizes="(min-width: 990px) 25vw, 50vw" alt="' + esc(title) + '" loading="lazy" data-wubs-pc-mainimg>' +
              '<div class="wubs-pc__carousel" data-wubs-pc-carousel>' +
                carouselImgs.join('') +
                '<div class="wubs-pc__imgdata" hidden data-wubs-pc-imgdata>' +
                  imgdataSpans.join('') +
                '</div>' +
              '</div>';
          } else {
            mediaHtml = '<div class="wubs-pc__img--placeholder"></div>';
          }

          var vendorHtml = '';
          if(PC_SHOW_VENDOR && vendor){
            vendorHtml = '<div class="wubs-pc__vendor">' + esc(vendor) + '</div>';
          }

          var stockHtml = '';
          if(PC_SHOW_STOCK){
            var productAvailable = p.available !== false;
            var stockClass = productAvailable ? '' : ' wubs-pc__stock--out';
            var stockText = productAvailable ? TEXT.inStock : TEXT.outOfStock;
            var stockDot = PC_STOCK_DOT ? '<span class="wubs-pc__stockDot" aria-hidden="true"></span>' : '';
            var stockStyle = '--wubs-pc-stock-in:' + esc(searchRoot.getAttribute('data-stock-in-color') || '#23833a') + ';' +
              '--wubs-pc-stock-out:' + esc(searchRoot.getAttribute('data-stock-out-color') || '#9a4b42') + ';' +
              '--wubs-pc-stock-text:' + esc(searchRoot.getAttribute('data-stock-text-color') || '#111') + ';' +
              '--wubs-pc-stock-size:' + esc(searchRoot.getAttribute('data-stock-text-size') || '10') + 'px;' +
              '--wubs-pc-stock-spacing:' + esc(searchRoot.getAttribute('data-stock-spacing') || '7') + 'px;' +
              '--wubs-pc-stock-case:' + esc(searchRoot.getAttribute('data-stock-case') || 'uppercase') + ';';
            stockHtml = '<div class="wubs-pc__stock' + stockClass + '" style="' + stockStyle + '">' + stockDot + '<span>' + esc(stockText) + '</span></div>';
          }

          return '' +
            '<article class="wubs-pc__card ' + (imgCount <= 1 ? 'is-single' : '') + '" data-wubs-pc-card>' +
              '<div class="wubs-pc__mediaWrap">' +
                '<a class="wubs-pc__mediaLink" href="' + esc(url) + '" aria-label="' + esc(title) + '" data-wubs-pc-media-link>' +
                  '<div class="wubs-pc__ratio">' +
                    mediaHtml +
                  '</div>' +
                '</a>' +
                arrowsHtml +
                atcHtml +
              '</div>' +
              '<div class="wubs-pc__meta">' +
                vendorHtml +
                '<div class="wubs-pc__title"><a href="' + esc(url) + '">' + esc(title) + '</a></div>' +
                '<div class="wubs-pc__price">' + esc(priceHtml) + '</div>' +
                stockHtml +
              '</div>' +
            '</article>';
        }

        /* Produktkort-interaktion (samma beteende som wubs-product-card) */
        function initProductCards(){
          if(grid.__wubsPcInit) return;
          grid.__wubsPcInit = true;

          var mqDesktop = window.matchMedia('(min-width: 750px)');
          var mqMobile  = window.matchMedia('(max-width: 749px)');

          function closestCard(el){
            return el && el.closest ? el.closest('[data-wubs-pc-card]') : null;
          }

          function openWubsCartDrawer(){
            var opened = false;

            try{
              document.dispatchEvent(new CustomEvent('wubs:cart-open'));
              opened = true;
            }catch(e){}

            if(!opened && window.wubsCartDrawerOpen){
              try{
                for(var k in window.wubsCartDrawerOpen){
                  if(typeof window.wubsCartDrawerOpen[k] === 'function'){
                    window.wubsCartDrawerOpen[k]();
                    opened = true;
                    break;
                  }
                }
              }catch(e){}
            }

            if(!opened){
              var dawnDrawer = document.querySelector('cart-drawer');
              if(dawnDrawer && typeof dawnDrawer.open === 'function'){
                dawnDrawer.open();
                opened = true;
              }
            }

            return opened;
          }

          function openQuickAdd(handle, url, variantId){
            var opened = false;

            try{
              document.dispatchEvent(new CustomEvent('wubs:quick-add-open', { detail: { handle: handle, url: url, variantId: variantId } }));
              opened = true;
            }catch(e){}

            if(!opened && window.wubsQuickAddOpen){
              try{
                for(var k in window.wubsQuickAddOpen){
                  if(typeof window.wubsQuickAddOpen[k] === 'function'){
                    window.wubsQuickAddOpen[k](handle, { url: url, variantId: variantId });
                    opened = true;
                    break;
                  }
                }
              }catch(e){}
            }

            if(!opened && url){
              window.location.href = url;
            }

            return opened;
          }

          function cartAdd(variantId){
            var url = rootPath() + 'cart/add.js';
            return fetch(url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
            }).then(function(r){
              if(!r.ok){
                return r.json().then(function(e){ throw e; });
              }
              return r.json();
            });
          }

          /* Hover state */
          grid.addEventListener('mouseover', function(e){
            if(!window.matchMedia('(hover:hover)').matches) return;
            var card = closestCard(e.target);
            if(!card) return;
            if(e.relatedTarget && card.contains(e.relatedTarget)) return;
            card.setAttribute('data-wubs-hover', '1');
          });

          grid.addEventListener('mouseout', function(e){
            if(!window.matchMedia('(hover:hover)').matches) return;
            var card = closestCard(e.target);
            if(!card) return;
            if(e.relatedTarget && card.contains(e.relatedTarget)) return;
            card.removeAttribute('data-wubs-hover');
          });

          function getImgItems(card){
            var wrap = card.querySelector('[data-wubs-pc-imgdata]');
            if(!wrap) return [];
            return Array.prototype.slice.call(wrap.querySelectorAll('[data-wubs-pc-imgitem]'));
          }
          function getIdx(card){
            var n = parseInt(card.dataset.wubsPcIdx || '0', 10);
            return isNaN(n) ? 0 : n;
          }
          function setIdx(card, idx){ card.dataset.wubsPcIdx = String(idx); }

          function swapTo(card, idx){
            if(!mqDesktop.matches) return;
            var main = card.querySelector('[data-wubs-pc-mainimg]');
            if(!main) return;

            var items = getImgItems(card);
            if(!items.length) return;

            var max = items.length;
            var i = idx % max;
            if(i < 0) i = max - 1;

            var it = items[i];
            var src = it.getAttribute('data-src');
            var srcset = it.getAttribute('data-srcset');

            if(src) main.src = src;
            if(srcset) main.setAttribute('srcset', srcset);

            setIdx(card, i);
          }

          /* Click delegation: nav + atc */
          grid.addEventListener('click', function(e){
            var t = e.target;

            var navBtn = t && t.closest ? t.closest('[data-wubs-pc-nav]') : null;
            if(navBtn && grid.contains(navBtn)){
              var cardN = closestCard(navBtn);
              if(!cardN) return;
              e.preventDefault();
              e.stopPropagation();
              if(!mqDesktop.matches) return;

              var items = getImgItems(cardN);
              if(items.length <= 1) return;

              var dir = navBtn.getAttribute('data-wubs-pc-nav');
              var cur = getIdx(cardN);
              swapTo(cardN, dir === 'prev' ? (cur - 1) : (cur + 1));
              return;
            }

            var atcBtn = t && t.closest ? t.closest('[data-wubs-pc-atc]') : null;
            if(atcBtn && grid.contains(atcBtn)){
              e.preventDefault();
              e.stopPropagation();

              if(atcBtn.hasAttribute('disabled')) return;

              var qa = (atcBtn.getAttribute('data-qa') === '1');
              var handle = atcBtn.getAttribute('data-handle') || '';
              var purl = atcBtn.getAttribute('data-url') || '';
              var vidRaw = atcBtn.getAttribute('data-vid') || (atcBtn.dataset ? atcBtn.dataset.vid : '');
              var vid = parseInt(vidRaw || '0', 10);

              if(qa && handle){
                openQuickAdd(handle, purl, vid);
                return;
              }

              if(!vid) return;

              atcBtn.setAttribute('aria-busy', 'true');

              cartAdd(vid)
                .then(function(){
                  var ok = openWubsCartDrawer();
                  if(!ok) window.location.href = rootPath() + 'cart';
                })
                .catch(function(err){
                  console.error('[wubs-ps] ATC error', err);
                  window.location.href = rootPath() + 'cart';
                })
                .finally(function(){
                  atcBtn.removeAttribute('aria-busy');
                });

              return;
            }
          }, true);

          /* Mobile: block click after swipe on image link */
          var touchState = { el: null, x: 0, y: 0, moved: false };

          grid.addEventListener('touchstart', function(e){
            if(!mqMobile.matches) return;
            var link = e.target.closest && e.target.closest('[data-wubs-pc-media-link]');
            if(!link) return;
            var t = e.touches && e.touches[0];
            if(!t) return;
            touchState.el = link;
            touchState.x = t.clientX;
            touchState.y = t.clientY;
            touchState.moved = false;
          }, { passive: true });

          grid.addEventListener('touchmove', function(e){
            if(!mqMobile.matches) return;
            if(!touchState.el) return;
            var t = e.touches && e.touches[0];
            if(!t) return;
            var dx = Math.abs(t.clientX - touchState.x);
            var dy = Math.abs(t.clientY - touchState.y);
            if(dx > 12 && dx > dy) touchState.moved = true;
          }, { passive: true });

          grid.addEventListener('click', function(e){
            if(!mqMobile.matches) return;
            var link = e.target.closest && e.target.closest('[data-wubs-pc-media-link]');
            if(!link) return;
            if(touchState.el === link && touchState.moved){
              e.preventDefault();
              e.stopPropagation();
              touchState.el = null;
              touchState.moved = false;
            }
          }, true);
        }

        initProductCards();

        var onType = debounce(function(){
          var term = (input.value || '').trim();

          if(!term){
            collapse();
            clearResults();
            showCollections([]);
            return;
          }

          /* Visa resultatytan först när man har skrivit något */
          expand();

          if(empty){
            empty.textContent = TEXT.searching;
            empty.hidden = false;
          }
          if(grid) grid.innerHTML = '';

          try{
            if(aborterJson) aborterJson.abort();
            if(aborterProducts) aborterProducts.abort();
          }catch(e){}

          aborterJson = new AbortController();

          fetch(buildUrl(term), { signal: aborterJson.signal, headers: { 'Accept': 'application/json' } })
            .then(function(r){ if(!r.ok) throw new Error(String(r.status)); return r.json(); })
            .then(function(json){
              var out = extract(json);

              showCollections(out.collections);

              var prods = out.products || [];
              if(!prods.length){
                if(empty){
                  empty.textContent = TEXT.empty;
                  empty.hidden = false;
                }
                if(grid) grid.innerHTML = '';
                return;
              }

              var handles = [];
              var seen = {};
              for(var i=0; i<prods.length && handles.length<DISPLAY_LIMIT; i++){
                var h = productHandle(prods[i]);
                if(!h) continue;
                if(seen[h]) continue;
                seen[h] = true;
                handles.push(h);
              }

              if(!handles.length){
                if(empty){
                  empty.textContent = TEXT.empty;
                  empty.hidden = false;
                }
                if(grid) grid.innerHTML = '';
                return;
              }

              aborterProducts = new AbortController();

              Promise.all(handles.map(function(h){
                return fetchProductJson(h, aborterProducts.signal)
                  .catch(function(){ return null; });
              }))
              .then(function(arr){
                var html = '';
                for(var j=0;j<arr.length;j++){
                  if(!arr[j]) continue;
                  html += buildCardHtml(arr[j]);
                }

                if(grid) grid.innerHTML = html;

                var hasCards = !!(grid && grid.querySelector('.wubs-pc__card'));
                if(empty){
                  empty.textContent = hasCards ? '' : TEXT.empty;
                  empty.hidden = hasCards;
                }
              })
              .catch(function(err){
                if(err && err.name === 'AbortError') return;
                if(grid) grid.innerHTML = '';
                if(empty){
                  empty.textContent = TEXT.empty;
                  empty.hidden = false;
                }
              });
            })
            .catch(function(err){
              if(err && err.name === 'AbortError') return;
              if(grid) grid.innerHTML = '';
              if(empty){
                empty.textContent = TEXT.empty;
                empty.hidden = false;
              }
              showCollections([]);
            });
        }, 140);

        /* Viktigt: kör i capture och stoppa temats egna sök */
        for(var b=0;b<searchBtns.length;b++){
          (function(btn){
            btn.addEventListener('click', function(e){
              e.preventDefault();
              e.stopPropagation();
              if(e.stopImmediatePropagation) e.stopImmediatePropagation();

              closeThemeSearch();

              if(header.classList.contains('is-search-open')){ close(); }
              else { open(); }
            }, true);
          })(searchBtns[b]);
        }

        if(form){
          form.addEventListener('submit', function(e){
            var term = (input.value || '').trim();
            if(!term){
              e.preventDefault();
              focusInputNow();
              return;
            }
            lockScroll(false);
          });
        }

        if(closeBtn) closeBtn.addEventListener('click', close);

        document.addEventListener('wubs:search-close', function(e){
          var detail = e && e.detail ? e.detail : {};
          if(detail.sid && detail.sid !== sid) return;
          if(header.classList.contains('is-search-open')) close();
        });

        document.addEventListener('keydown', function(e){
          if(e.key === 'Escape' && header.classList.contains('is-search-open')) close();
        });

        input.addEventListener('input', onType);

        window.addEventListener('resize', function(){
          setDockVar();
          updateBackdrop();
        }, { passive:true });

        if('ResizeObserver' in window && dockInner){
          var ro = new ResizeObserver(function(){
            setDockVar();
            updateBackdrop();
          });
          ro.observe(dockInner);
        }

        setDockVar();
        updateBackdrop();
      })();
